// Translation: Terms of service > Landing > Form (Ukrainian)
export default Object.freeze({})
